import { PillTextbox } from '../types';
import { calcPillWidth } from './render-pill';

/** Resizes the pill to fit its content. */
export function resizePillToFit(pill: PillTextbox): void {
  pill.set({
    width: calcPillWidth(pill),
    height: pill.calcTextHeight()
  });

  // Refresh the pill position after changing its size.
  pill.setCoords();
  pill.dirty = true;
  pill.canvas?.requestRenderAll();
}
